import * as ActionTypes from './index';

//action that requests the posted application mesage
export function getPostedApplicationMessage(payload) {
    return {
        type: ActionTypes.GET_POSTED_APPLICATION_MESSAGE,
		payload
    }
}

export function getPostedApplicationMessageSuccess(payload) {
    return {
        type: ActionTypes.GET_POSTED_APPLICATION_MESSAGE_SUCCESS,
        payload
    }
}

export function getPostedApplicationMessageFail(payload) {
    return {
        type: ActionTypes.GET_POSTED_APPLICATION_MESSAGE_FAIL,
        payload
    }
}